/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Developer_Redirect_UrisInputs */



/**
* | output |
* | --- |
* | "Redirect URIs (one per line)" |
*
* @param {Developer_Redirect_UrisInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const developer_redirect_uris = /** @type {((inputs?: Developer_Redirect_UrisInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Developer_Redirect_UrisInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("URI de redirection (une par ligne)")
	if (locale === "es") return /** @type {LocalizedString} */ ("URIs de redirección (una por línea)")
	if (locale === "pt") return /** @type {LocalizedString} */ ("URIs de Redirecionamento (uma por linha)")
	if (locale === "it") return /** @type {LocalizedString} */ ("URI di Reindirizzamento (uno per riga)")
	return /** @type {LocalizedString} */ ("Redirect URIs (one per line)")
});